<div class="p-4">
  <table class="main-window">
    <tbody #main>
      <tr>
        <td>
          <div
            class="m-4 p-4 bg-white"
            style="width: 400px; min-height: 326px; border: 1px solid #ccc; border-radius: 0.5rem"
          >
            @if (loading) {
              <div
                class="spinner-border spinner-border-md"
                role="status"
              >
                <span class="sr-only">Loading...</span>
              </div>
            }
            @if (logout && !loading) {
              <div class="d-flex flex-column text-center">
                <i class="fa fa-sign-out fa-4x mb-1"></i>
                <h1>Session Ended</h1>
                <p class="lead mb-2">You were successfully signed out of the portal</p>
                <button
                  type="button"
                  (click)="returnToLogin()"
                  class="btn btn-primary text-uppercase font-weight-bold"
                >
                  <i class="fa fa-arrow-left fa-2x mr-2"></i>
                  Back to sign in
                </button>
              </div>
            }
            @if (!logout && !loading) {
              <div class="d-flex flex-column text-center">
                <h1>There was a problem</h1>
                <p class="lead mb-2">{{ message }} please click logout to retry</p>
                <button
                  type="button"
                  (click)="retryLogout()"
                  class="btn btn-primary text-uppercase font-weight-bold"
                >
                  <i class="fa fa-sign-out fa-4x mb-1"></i>
                  Logout
                </button>
              </div>
            }
          </div>
        </td>
        <td style="vertical-align: baseline">
          <div class="p-4">
            <div
              class="my-4"
              style="text-align: center"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 252.2 54.7"
                width="250"
                height="45"
              >
                <path
                  fill="currentColor"
                  d="M242.7 38.8c-1.8 0-3.3 1.5-3.3 3.3 0 1.8 1.5 3.3 3.3 3.3 1.8 0 3.3-1.5 3.3-3.3 0-1.8-1.5-3.3-3.3-3.3zm0 6.1c-1.5 0-2.8-1.2-2.8-2.8s1.2-2.8 2.8-2.8c1.5 0 2.8 1.2 2.8 2.8s-1.3 2.8-2.8 2.8zm1.3-3.5c0-.7-.4-1-1.2-1h-1.3v3.5h.6v-1.4h.5l.9 1.4h.7l-.9-1.5c.4-.1.7-.4.7-1zm-1.9.5v-1h.5c.4 0 .8 0 .8.5s-.4.5-.8.5h-.5z"
                />
                <path
                  fill="currentColor"
                  d="M252.2 18l-17.9 28.2c-3.5 5.5-6 8-10.9 8H215l2-7.1h.2c.8 0 3.2.1 4.2-.3s1.5-1.3 1.8-2.8l-1.8-20.1h-6.6l-2.8 9.9c-.2.8-.4 1.7-.4 2.3 0 1.1.5 1.5 2.1 1.5h2.6l-1.8 6.4h-11c-3.6 0-5-1.8-5-4.4 0-1.1.1-2.3.5-3.6l6.7-23.7H218l-1.6 5.8h16.8l-.2 14.4 6.7-14.4h12.5zM87.6 22.9h-13l1.7-6.1h13l2.4-8.4H66.2L56.2 44h12.5l3.7-13.3h13l2.2-7.8zm19.9-14.5H95.2l-2 7.1h12.3l2-7.1zm-15 9.6l-7.3 26h12.3l7.3-26H92.5zm110.3-9.6h-12.3l-2 7.1h12.3l2-7.1zm-55.6 24.3c-.3 1.4-.7 2.3-.7 3.4 0 .5.1 1.9 1.8 1.9s2.5-.7 3.2-3.2h12.1c-1.5 7.4-10.3 9.9-15.7 9.9-7.3 0-13-1-13-8.1 0-3.9 2-10.3 4.5-13.7 3.1-4.1 8.5-5.6 13.5-5.6 7.6 0 12.6 1.6 12.6 8.1 0 1.6-.7 5.1-1.3 7.2h-17zm1.5-5.1h5.1c.1-.5.3-1.3.3-1.8 0-1.4-.9-1.9-2.1-1.9-1.6 0-2.7 1.1-3.3 3.7zm-9.3-19.2l-10 35.6h-12.1l.9-2.9c-2.4 2.1-4.9 3.5-8.9 3.5s-6.5-1.9-6.5-6c0-4.5 1.8-11.2 4.4-15.8 1.9-3.5 5.3-5.3 9.4-5.3 3.5 0 6.1 1.5 7.1 3.4l3.4-12.6h12.3zm-17.2 18.4c-.4-.6-1.2-1.1-2-1.1-1.1 0-2.2.3-2.8 1.9-.9 2.2-1.7 4.3-1.7 6.5 0 1 .7 1.9 1.9 1.9 1 0 1.6-.3 2.1-.6l2.5-8.6zm65.7-8.8l-7.3 26h12.3l7.3-26h-12.3zm-13.6-9.6l-10 35.6h12.3l10-35.6h-12.3z"
                />
                <path
                  fill="currentColor"
                  d="M56 48h3.1l-2 6.4H54l2-6.4zm10.7 0h4.5l1.2 4.3 1.3-4.3h2.7l-2 6.4h-4.3l-1.2-4.6-1.4 4.6h-2.7l1.9-6.4zm15.4 0h3.4l.6 4 3.1-4h3.1l-5.2 6.4h-3.8L82.1 48zm16.1 0h7l-.4 1.3h-4l-.4 1.3h3.8l-.4 1.2H100l-.4 1.3h4.1l-.4 1.3h-7l1.9-6.4zm30 1.6h-2.4l.5-1.6h7.8l-.5 1.6h-2.4l-1.5 4.8h-3.1l1.6-4.8zm12.3-1.6h4.7l.2 4.3 2.8-4.3h4.7l-1.9 6.4h-2.8l1.5-4.8-3.5 4.8h-3l-.4-4.8-1.5 4.8h-2.6l1.8-6.4zm31.9 0h4.5l1.2 4.3 1.3-4.3h2.7l-1.9 6.4h-4.4l-1.2-4.6-1.4 4.6h-2.7l1.9-6.4zm17 1.6H187l.5-1.6h7.8l-.5 1.6h-2.4l-1.5 4.8h-3.1l1.6-4.8zm-74.8.4c-.1-.1-.1-.2 0-.3.1-.3.5-.5 1.2-.5.4 0 1 0 1.1.2.2.1.2.3.2.5h2.7c.3-1.1-.4-1.9-3.5-1.9-2.9 0-4.6.6-5 2-.1.4-.1.8.2 1.1.8.7 4.1 1 4.4 1.4.1.1.1.2 0 .3-.2.5-.9.6-1.5.6-.4 0-.9-.1-1.1-.3-.1-.2-.1-.4-.1-.6h-2.8c-.3 1-.4 2 3.5 2 3.3 0 4.8-.8 5.2-2.1.2-.6 0-1-.2-1.2-.7-.6-3.9-.8-4.3-1.2zm44.5-2h7l-.4 1.3h-4l-.4 1.3h3.8l-.4 1.2h-3.8l-.4 1.3h4.1l-.4 1.3h-7l1.9-6.4zm44.2 2c-.1-.1-.1-.2 0-.3.1-.3.5-.5 1.2-.5.4 0 1 0 1.1.2.2.1.2.3.2.5h2.7c.3-1.1-.4-1.9-3.5-1.9-2.9 0-4.6.6-5 2-.1.4-.1.8.2 1.1.8.7 4.1 1 4.4 1.4.1.1.1.2 0 .3-.2.5-.9.6-1.5.6-.4 0-.9-.1-1.1-.3-.1-.2-.1-.4-.1-.6h-2.8c-.3 1-.4 2 3.5 2 3.3 0 4.8-.8 5.2-2.1.2-.6 0-1-.2-1.2-.7-.6-4-.8-4.3-1.2z"
                />
                <path
                  fill="transparent"
                  d="M1.2 26.3c0-13.9 11.2-25.1 25.1-25.1 13.8 0 25.1 11.2 25.1 25.1S40.1 51.1 26.3 51.1c-13.9 0-25.1-10.9-25.1-24.8z"
                />
                <path
                  fill="currentColor"
                  d="M26.2 19.6l-6 9.6 1.8 1.3h-2.6L17.2 34l-9.7 5.1h-.2c-.1 0 0-.1 0-.1l12.1-10.2-15.3 1.8v-.1L19 26.1 4 21.7c-.1 0-.1-.1 0-.1l15.4 1.6-12.1-9.8s0-.1.1-.1L21 20.7 13.8 7s.1-.1.1 0l9.5 12.4-1.1-16c0-.1.1 0 .1 0l4 15.4 4.6-15h.1l-1.9 15.4 10-11.7c.1 0 .1 0 .1.1l-7.7 13.5 13.9-7c0-.1.1 0 .1 0l-12.3 9.3 15.8-1v.1l-15.4 3.7 14.8 5.2.1.1h-.1l-15.7-2.4 12.1 10.5s0 .1-.1.1l-9.3-5.2 6.7 11.1c3.9-3.1 6.7-7.4 8.1-11.9 2.2-6.8 1.2-14.3-2.4-20.3C44.7 8 39.2 3.9 33.4 2.2 28.4.6 22 .9 17.2 2.8c-6 2.3-11.7 7.7-14.1 13.7C.6 22.4.6 29.7 3 35.6c2.3 6 7.8 11.4 13.8 13.7l5.4-16.7h12l-2.6-1.7h-9l3.6-11.3z"
                />
              </svg>
            </div>
            <div class="d-flex align-items-center mb-2">
              <span
                class="fa fa-circle text-success mr-2"
                style="font-size: 9px"
              ></span>
              <span>
                For Login support, please email
                <a href="mailto:Fidelityloginsupport@fmr.com">Fidelityloginsupport&#64;fmr.com</a>
              </span>
            </div>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</div>
